const headerHeightDifference = 50;

function offset(elt) {
  var rect = elt.getBoundingClientRect(), bodyElt = document.body.getBoundingClientRect();
  if (document.scrollingElement.scrollTop > 0) {
    extraTop = headerHeightDifference;
  } else {
    extraTop = 0;
  }
  return {
    top: rect.top - bodyElt.top + extraTop,
    left: rect.left - bodyElt.left
  }
}


window.addEventListener('load', function(){
  if (document.querySelector('.page-nav__nav')){

    const sidebar = document.querySelector('.page-nav__nav');
    const footer = document.querySelector('.site-footer');
    const header = document.querySelector('.site-header');
    const top = offset(sidebar).top;
    const footTop = offset(footer).top;
    const gutter = parseFloat(getComputedStyle(document.body).getPropertyValue('--gutter'));
    const maxY = footTop - sidebar.offsetHeight - gutter;

    function pageNavScroll() {

      const bannerPaddingTop = parseFloat(getComputedStyle(document.querySelector('.banner')).paddingTop);
      const stickyScrollStart = bannerPaddingTop + gutter + headerHeightDifference;
      let y = document.scrollingElement.scrollTop + stickyScrollStart;
      if (y > top) {
        if (y < maxY) {
          sidebar.classList.add('fixed');
          sidebar.removeAttribute('style');
        } else {
          sidebar.classList.remove('fixed');
          sidebar.setAttribute('style', 'position: absolute; top: '+(maxY - bannerPaddingTop + headerHeightDifference)+'px');
        }
      } else {
        sidebar.classList.remove('fixed');
      }

    }

    window.addEventListener('scroll', function(){
      pageNavScroll();
    });

    pageNavScroll();
  }
});
